import $ from 'jquery'
import lottie from 'lottie-web'

const animationData = require(`${__dirname}/lines-data`)
var linesAnimations = []
var divContainers = document.getElementsByClassName('js-hero-section-lines')

Array.from(divContainers).forEach(el => {
  var params = {
    container: el,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: animationData,
  }
  linesAnimations.push(lottie.loadAnimation(params))
})

$(window).load(function () {
  linesAnimations.forEach(function (animation) {
    animation.setSpeed(1.5)
    animation.play()
  })
})

$(document).ready(function () {
  $('.dhsv_vc_hero_section_video video').each(function () {
    var mobilevideo = $(this).data('video-mobile')
    var wwidth = $(window).width()
    if (mobilevideo != '' && wwidth < 769) {
      $(this).find('source').attr('src', mobilevideo)
      $(this)[0].load()
    }
  })
})
